<script lang="ts">
  import Vue from "vue";
  import CodeMirrorEditorComponent from "../../components/formulas/code-mirror-editor.vue"
  import FormulaMixin from "../../mixins/formulaMixin";
  import {IReplaceContentConfig} from "../../helpers/codeMirrorEditor";
  import {IDynamicFieldsOptions} from "~/interfaces/dynamicFieldsInterfaces/dynamicOptionsInterfaces";

  export default Vue.extend({
    extends: CodeMirrorEditorComponent,
    mixins: [
      FormulaMixin,
    ],
    props: {
      dynamicOptions: {
        type: Array as () => Array<IDynamicFieldsOptions>,
        default: []
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.updateContent();
      })
    },
    methods: {
      updateContent() {
        const replaceContentConfig: IReplaceContentConfig<string> = {
          referencedThingLookupFunction: this.getReferencedThingFromFormulaValue,
          widgetListener: this.openInsertFormFieldMenuOnClick
        };
        if (this.dynamicOptions && this.dynamicOptions[0]?.props?.fieldsHandler) {
          replaceContentConfig["fieldsHandler"] = this.dynamicOptions[0].props.fieldsHandler
        }
        this.editor.replaceContent(replaceContentConfig);
        this.editor.setInputReadListener( (cm, ch) => {
          this.editor.replaceContent(replaceContentConfig);
        })
      },
      openInsertFormFieldMenuOnClick(e): void {
        if ($(e.target).hasClass('active')) {
          this.$emit('openFieldsPopupMenu', e);

        }
      },
    },
    watch: {
      '$data._value': function(newVal: string) {
        if (newVal !== undefined) {
          this.$nextTick(() => {
            this.emitInput();
          });
        }
      }
    }
  });
</script>